export default "__VITE_ASSET__BJht7lrZ__"